<template>
  <div class="header">
    <div class="search"></div>
    <div>
      <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
        >刷新</el-button
      >
      <el-button
        size="small"
        icon="el-icon-plus"
        @click="onAdd"
        type="primary"
        v-if="roleList[path].includes('_Add')"
        >新增</el-button
      >
      <!-- <el-button  size="small" icon="el-icon-edit" @click="onEdit" type="info" >编辑</el-button> -->
      <el-button
        size="small"
        icon="el-icon-delete"
        @click="onRemove"
        type="danger"
        v-if="roleList[path].includes('_Delete')"
        >批量删除</el-button
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { removeFormApi } from '@/api/areaApi';
export default {
  name: 'citySearchBar',
  // 与 APP.vue 组件配合使用 provide / inject组合
  inject: ['reload', 'getAreaList'], // 注入reload方法
  data() {
    return {
      formInline: {
        searchValue: '',
        newsDate: '',
        classify: '',
        path: '',
      },
    };
  },
  computed: {
    ...mapGetters(['checkAreaListID', 'roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  methods: {
    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 增加
    onAdd() {
      this.$parent.$refs.addCity.dialogFormVisible = true;
    },

    // 编辑
    // onEdit () {
    //   if (this.checkAreaListID.length === 0) return this.$message.error('请选择要编辑的城市')
    //   this.$parent.$refs.editCity.dialogFormVisible = true
    // },

    // 删除
    onRemove() {
      try {
        if (this.checkAreaListID.length === 0)
          return this.$message.error('请选择要删除的城市');
        this.$confirm('是否狠心删除该城市', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        })
          .then(async () => {
            await removeFormApi(this.checkAreaListID).then((res) => {
              this.$parent.getAreaAllData();
              this.$store.dispatch(
                'area/deleteCheckNodeData',
                this.checkAreaListID
              );
              if (res.code == 200) {
                this.$message.success('删除成功!');
              } else {
                // this.$message.warning(res.message);
              }
            });
          })
          .catch(() => {
            // this.$message.info('已取消删除')
          });
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .search {
    display: flex;
    width: 300px;

    .search-input {
      margin: 0 10px;
      width: 300px;
    }

    .search-picker {
      width: 250px;
    }

    .search-select {
      margin-right: 10px;
    }
  }

  button {
    height: 40px;
  }
}
</style>
